import i18n from '../../../i18n'

const replaceDate = (phrase: string, date: string) => {
  phrase.replace('$1', date)
}

const phrases = {
  calendarLabel: i18n.t('BBO_1438_calendar_label'),
  chooseAvailableDate: ({ date }) => date,
  chooseAvailableEndDate: ({ date }) =>
    replaceDate(i18n.t('BBO_1438_choose_available_end_date'), date),
  chooseAvailableStartDate: ({ date }) =>
    replaceDate(i18n.t('BBO_1438_choose_available_start_date'), date),
  clearDate: i18n.t('BBO_1438_clear_date'),
  clearDates: i18n.t('BBO_1438_clear_dates'),
  closeDatePicker: i18n.t('BBO_1438_close_date_picker'),
  dateIsSelected: ({ date }) =>
    replaceDate(i18n.t('BBO_1438_date_is_selected'), date),
  dateIsSelectedAsEndDate: ({ date }) =>
    replaceDate(i18n.t('BBO_1438_date_is_selected_as_end_date'), date),
  dateIsSelectedAsStartDate: ({ date }) =>
    replaceDate(i18n.t('BBO_1438_date_is_selected_as_start_date'), date),
  dateIsUnavailable: ({ date }) =>
    replaceDate(i18n.t('BBO_1438_date_is_unavailable'), date),
  enterKey: i18n.t('BBO_1438_enter_key'),
  escape: i18n.t('BBO_1438_escape'),
  focusStartDate: i18n.t('BBO_1438_focus_start_date'),
  hideKeyboardShortcutsPanel: i18n.t('BBO_1438_hide_keyboard_shortcuts_panel'),
  homeEnd: i18n.t('BBO_1438_home_end'),
  jumpToNextMonth: i18n.t('BBO_1438_jump_to_next_month'),
  jumpToPrevMonth: i18n.t('BBO_1438_jump_to_prev_month'),
  keyboardBackwardNavigationInstructions: i18n.t(
    'BBO_1438_keyboard_backward_navigation_instructions',
  ),
  keyboardForwardNavigationInstructions: i18n.t(
    'BBO_1438_keyboard_forward_navigation_instructions',
  ),
  keyboardShortcuts: i18n.t('BBO_1438_keyboard_shortcuts'),
  leftArrowRightArrow: i18n.t('BBO_1438_left_arrow_right_arrow'),
  moveFocusByOneDay: i18n.t('BBO_1438_move_focus_by_one_day'),
  moveFocusByOneMonth: i18n.t('BBO_1438_move_focus_by_one_month'),
  moveFocusByOneWeek: i18n.t('BBO_1438_move_focus_by_one_week'),
  moveFocustoStartAndEndOfWeek: i18n.t(
    'BBO_1438_move_focusto_start_and_end_of_week',
  ),
  openThisPanel: i18n.t('BBO_1438_open_this_panel'),
  pageUpPageDown: i18n.t('BBO_1438_page_up_page_down'),
  questionMark: i18n.t('BBO_1438_question_mark'),
  returnFocusToInput: i18n.t('BBO_1438_return_focus_to_input'),
  roleDescription: i18n.t('BBO_1438_role_description'),
  selectFocusedDate: i18n.t('BBO_1438_select_focused_date'),
  showKeyboardShortcutsPanel: i18n.t('BBO_1438_show_keyboard_shortcuts_panel'),
  upArrowDownArrow: i18n.t('BBO_1438_up_arrow_down_arrow'),
}

export default phrases
